import { getGrocery } from "@/services";
import { openUdesk } from "@/utils/initUdesk";
import useRequest from "@/utils/useReq";
import { Dropdown } from "antd";
import { useCallback, useMemo, useState } from "react";
import { Else, If, Then } from "react-if";
import HBIcon from "../HBIcon";
import Image from "../Image";
import styles from "./index.module.less";

function QrcodeButton({ data }) {
  const [visible, setVisible] = useState(false);

  const overlay = useMemo(() => {
    return (
      <div className={styles.qrcode}>
        <div className={styles.img}>
          <img src={data.qrcode[0]?.url} alt={data.title} />
        </div>
        <div className={styles.desc}>扫码关注</div>
        <div className={styles.desc}>{data.title}</div>
      </div>
    );
  }, [data]);

  const onVisibleChange = useCallback((visible) => {
    setVisible(visible);
  }, []);

  return (
    <Dropdown
      overlay={overlay}
      placement="topCenter"
      onVisibleChange={onVisibleChange}
    >
      <div className={styles.icon} style={{ color: visible ? data.color : "" }}>
        <HBIcon type={data.icon} />
      </div>
    </Dropdown>
  );
}

function FooterLink({ data }) {
  return (
    <li className={styles.item}>
      <If condition={data.url === "udesk"}>
        <Then>
          <span onClick={openUdesk}>{data.text}</span>
        </Then>
        <Else>
          <a href={data.url} target="_blank" rel="nofollow noreferrer">
            {data.text}
          </a>
        </Else>
      </If>
    </li>
  );
}

export default function AboutFooter(props) {
  const [data, setData] = useState(null);
  const {
    logoInfo = {
      src: "https://cdn.dancf.com/fe-assets/img/125b60523018210d81196ab379a02ff8.svg",
      width: 93,
      height: 28,
    },
  } = props;
  useRequest(async () => {
    const data = await getGrocery("about-bottom");
    setData(data);
  });

  if (!data) {
    return null;
  }

  return (
    <div className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.main}>
          <div
            className={styles.logo}
            style={{
              width: logoInfo.width,
              height: logoInfo.height,
            }}
          >
            <Image alt="花瓣网" {...logoInfo} />
          </div>
          <div className={styles.desc}>超过40亿灵感等你来发现</div>
          <div className={styles.contact}>
            {data?.connect.map((item) => (
              <QrcodeButton key={item.title} data={item} />
            ))}
          </div>
        </div>
        <div className={styles.group}>
          <div className={styles.title}>关于花瓣</div>
          <div className={styles.wrap}>
            <ul className={styles.list}>
              {data?.about.map((item) => (
                <FooterLink key={item.text} data={item} />
              ))}
            </ul>
          </div>
        </div>
        <div className={styles.group}>
          <div className={styles.title}>联系我们</div>
          <div className={styles.wrap}>
            <ul className={styles.list}>
              {data?.contact.map((item) => (
                <FooterLink key={item.text} data={item} />
              ))}
            </ul>
          </div>
        </div>
        <div className={styles.group}>
          <div className={styles.title}>友情链接</div>
          <div className={styles.wrap}>
            <ul className={styles.list}>
              {data?.link1.map((item) => (
                <FooterLink key={item.text} data={item} />
              ))}
            </ul>
            <ul className={styles.list}>
              {data?.link2.map((item) => (
                <FooterLink key={item.text} data={item} />
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
